import { defineMessages } from 'react-intl';

export default defineMessages({
  closeAbandonedCartModalButtonLabel: {
    id: 'AbandonedCartToast.closeAbandonedCartModalButtonLabel',
    description: 'Label for the close modal button',
    defaultMessage: 'Close promo modal',
  },
  applyPromoButtonLabel: {
    id: 'AbandonedCartToast.applyPromoButtonLabel',
    description: 'Label for the apply promo button',
    defaultMessage: 'Apply promo',
  },
});
